import { render, staticRenderFns } from "./RcIdentifyResponse.vue?vue&type=template&id=5a6d17c6"
import script from "./RcIdentifyResponse.vue?vue&type=script&lang=js"
export * from "./RcIdentifyResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports